<div class="unsupported-locations-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Unsupported Locations</h1>
        <p>Review and manage unsupported geo locations</p>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="filter-header">
      <h3><i class="fas fa-filter"></i> Filter Unsupported Locations</h3>
      <button class="clear-filters-btn" (click)="clearFilters()" [disabled]="!hasActiveFilters()">
        <i class="fas fa-times"></i> Clear Filters
      </button>
    </div>

    <div class="filter-form">
      <div class="filter-row">
        <div class="filter-group">
          <label for="geoZoneFilter">Geo Zone <span class="required">*</span></label>
          <select
            id="geoZoneFilter"
            [(ngModel)]="filters.geoZoneId"
            class="filter-select"
            required>
            <option value="">Select Geo Zone</option>
            <option *ngFor="let zone of zones" [value]="zone.id">
              {{ zone.name }}
            </option>
          </select>
          <div *ngIf="loadingZones" class="loading-place-types">
            <i class="fas fa-spinner fa-spin"></i> Loading zones...
          </div>
        </div>

        <div class="filter-group">
          <label for="statusFilter">Status</label>
          <select
            id="statusFilter"
            [(ngModel)]="filters.status"
            class="filter-select">
            <option value="">All Statuses</option>
            <option value="Pending">Pending</option>
            <option value="Converted">Converted</option>
            <option value="Rejected">Rejected</option>
            <option value="Invalid">Invalid</option>
            <option value="FollowUp">FollowUp</option>
          </select>
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-actions" style="display: flex; gap: 10px;">
          <button
            *ngIf="locationsResponse && locationsResponse.items && locationsResponse.items.length > 0"
            class="apply-filters-btn"
            style="background: #25d366;"
            (click)="openGeoZoneLaunchModal()">
            <i class="fab fa-whatsapp"></i> Notify Launch (WhatsApp)
          </button>
          <button
            *ngIf="filters.geoZoneId"
            class="apply-filters-btn"
            style="background: #495057;"
            (click)="openSendLogPanel()">
            <i class="fas fa-list-check"></i> View Send Log
          </button>
          <button class="apply-filters-btn" (click)="applyFilters()" [disabled]="!canLoadLocations()">
            <i class="fas fa-search"></i> Load Locations
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div class="error-message" *ngIf="errorMessage">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>

  <!-- Success Message -->
  <div class="success-message" *ngIf="successMessage">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>

  <!-- Loading State -->
  <div class="loading" *ngIf="loading && !locationsResponse">
    <p><i class="fas fa-spinner fa-spin"></i> Loading unsupported locations...</p>
  </div>

  <!-- Locations Table -->
  <div class="table-container" *ngIf="locationsResponse">
    <div class="pagination-summary">
      <p>Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalCount || 0) }} of {{ totalCount || 0 }} locations</p>
    </div>

    <table class="leads-table">
      <thead>
        <tr>
          <th class="col-business">User / Name</th>
          <th class="col-phone">Phone Number</th>
          <th class="col-status">Status</th>
          <th class="col-updated">Date</th>
          <th class="col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let loc of locationsResponse.items || []" class="lead-row">
          <td class="col-business">
            <strong>{{ loc.name || 'N/A' }}</strong>
            <div class="address-preview">
              <span class="coordinates">
                {{ loc.latitude | number:'1.6-6' }}, {{ loc.longitude | number:'1.6-6' }}
              </span>
            </div>
          </td>
          <td class="col-phone">
            <div class="phone-number" *ngIf="loc.phoneNumber; else noPhone">
              {{ loc.phoneNumber }}
            </div>
            <ng-template #noPhone>
              <span class="no-data">N/A</span>
            </ng-template>
          </td>
          <td class="col-status">
            <span [class]="getStatusBadgeClass(loc.status)">{{ loc.status || 'N/A' }}</span>
          </td>
          <td class="col-updated">
            <div class="last-updated" *ngIf="loc.date">
              {{ loc.date | date:'short' }}
            </div>
            <span *ngIf="!loc.date" class="no-data">N/A</span>
          </td>
          <td class="col-actions">
            <div class="action-buttons">
              <button
                class="view-btn"
                (click)="viewLocationDetails(loc)"
                title="View Details">
                <i class="fas fa-eye"></i> View
              </button>
              <button
                class="update-status-btn"
                (click)="openUpdateStatusModal(loc)"
                title="Update Status">
                <i class="fas fa-edit"></i> Update Status
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="!locationsResponse.items || locationsResponse.items.length === 0">
          <td colspan="5" class="no-leads">
            <p>No locations found.</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination Component -->
  <app-pagination
    *ngIf="locationsResponse"
    [page]="currentPage"
    [totalPages]="totalPages"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </app-pagination>

  <!-- Location Details Panel -->
  <div class="details-panel-overlay" *ngIf="showDetailsPanel" (click)="closeDetailsPanel()">
    <div class="details-panel" (click)="$event.stopPropagation()">
      <div class="details-header">
        <h2>Location Details</h2>
        <button class="close-btn" (click)="closeDetailsPanel()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="details-body" *ngIf="selectedLocation">
        <div class="detail-section">
          <h3>Basic Information</h3>
          <div class="detail-item">
            <label>Name:</label>
            <span>{{ selectedLocation.name || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <label>User Id:</label>
            <span>{{ selectedLocation.userId || 'N/A' }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedLocation.phoneNumber">
            <label>Phone Number:</label>
            <span>{{ selectedLocation.phoneNumber }}</span>
          </div>
        </div>

        <div class="detail-section">
          <h3>Location</h3>
          <div class="detail-item">
            <label>Coordinates:</label>
            <span>{{ selectedLocation.latitude | number:'1.6-6' }}, {{ selectedLocation.longitude | number:'1.6-6' }}</span>
          </div>
          <div class="detail-item">
            <label>Date:</label>
            <span *ngIf="selectedLocation.date">{{ selectedLocation.date | date:'short' }}</span>
            <span *ngIf="!selectedLocation.date" class="no-data">N/A</span>
          </div>
        </div>

        <div class="detail-section">
          <h3>Status</h3>
          <div class="detail-item">
            <label>Current Status:</label>
            <span [class]="getStatusBadgeClass(selectedLocation.status)">{{ selectedLocation.status || 'N/A' }}</span>
          </div>
        </div>

        <div class="detail-section" *ngIf="selectedLocation.remarks && selectedLocation.remarks.length > 0">
          <h3>Remarks</h3>
          <div class="remarks-history">
            <div class="remark-item" *ngFor="let remark of selectedLocation.remarks">
              <div class="remark-header">
                <span [class]="getStatusBadgeClass(remark.status)">{{ remark.status }}</span>
                <span class="remark-date">{{ remark.createdAt | date:'short' }}</span>
              </div>
              <div class="remark-text">{{ remark.comment }}</div>
              <div class="remark-meta">
                <span>by {{ remark.createdBy }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Update Status Modal -->
  <div class="modal-overlay" *ngIf="showUpdateStatusModal" (click)="closeUpdateStatusModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Update Location Status</h2>
        <button class="close-btn" (click)="closeUpdateStatusModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body" *ngIf="locationForStatusUpdate">
        <div class="lead-info">
          <p><strong>Name:</strong> {{ locationForStatusUpdate.name || 'N/A' }}</p>
          <p><strong>Phone:</strong> {{ locationForStatusUpdate.phoneNumber || 'N/A' }}</p>
        </div>

        <form (ngSubmit)="updateLocationStatus()">
          <div class="form-group">
            <label for="status">Status *</label>
            <select
              id="status"
              [(ngModel)]="updateStatusForm.status"
              name="status"
              class="form-control"
              required>
              <option value="">Select Status</option>
              <option value="Pending">Pending</option>
              <option value="Converted">Converted</option>
              <option value="Rejected">Rejected</option>
              <option value="Invalid">Invalid</option>
              <option value="FollowUp">FollowUp</option>
            </select>
          </div>

          <div class="form-group">
            <label for="remark">Remark</label>
            <textarea
              id="remark"
              [(ngModel)]="updateStatusForm.remark"
              name="remark"
              placeholder="Enter remark (optional)..."
              rows="4"
              class="form-control">
            </textarea>
          </div>

          <div class="error-message" *ngIf="errorMessage">
            <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
          </div>

          <div class="success-message" *ngIf="successMessage">
            <i class="fas fa-check-circle"></i> {{ successMessage }}
          </div>

          <div class="modal-actions">
            <button type="button" class="cancel-btn" (click)="closeUpdateStatusModal()">Cancel</button>
            <button type="submit" class="save-btn" [disabled]="loading || !updateStatusForm.status.trim()">
              <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
              <span *ngIf="!loading">Save</span>
              <span *ngIf="loading">Saving...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Geo-Zone Launch Notification Side Panel -->
  <div class="details-panel-overlay" *ngIf="showGeoZoneLaunchModal" (click)="closeGeoZoneLaunchModal()">
    <div class="details-panel" (click)="$event.stopPropagation()">
      <div class="details-header" style="background: linear-gradient(135deg, #128c7e 0%, #25d366 100%);">
        <h2>Send Geo-Zone Launch Notification</h2>
        <button class="close-btn" (click)="closeGeoZoneLaunchModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="details-body">
        <div class="lead-info" style="border-left: 4px solid #128c7e; margin-bottom: 20px; padding: 15px; background: #f0fbf0; border-radius: 8px;">
          <p style="margin: 0; color: #128c7e; font-size: 0.95rem;">You are about to notify all waitlisted customers in this zone. Sends happen asynchronously after you submit — numbers already notified for this zone are skipped automatically.</p>
        </div>

        <form (ngSubmit)="launchGeoZoneNotification()">
          <div class="form-group">
            <label for="whatsAppTemplateName">WhatsApp Template Name *</label>
            <input
              id="whatsAppTemplateName"
              [(ngModel)]="whatsAppTemplateName"
              name="whatsAppTemplateName"
              class="form-control"
              required
              readonly
              placeholder="e.g. location_launch_direct" />
          </div>

          <div class="form-group">
            <label for="whatsAppLocationParam">Location Parameter (maps to {{'{{2}}'}}) *</label>
            <input
              id="whatsAppLocationParam"
              [(ngModel)]="whatsAppLocationParam"
              name="whatsAppLocationParam"
              class="form-control"
              required
              placeholder="e.g. Kollam" />
            <small style="color: #666; font-size: 0.8rem; display: block; margin-top: 4px;">
              Note: The recipient's customer name will automatically be mapped as parameter {{'{{1}}'}}.
            </small>
          </div>

          <div class="form-group">
            <label for="whatsAppHeaderImageUrl">Header Image URL (Optional Banner)</label>
            <input
              id="whatsAppHeaderImageUrl"
              [(ngModel)]="whatsAppHeaderImageUrl"
              name="whatsAppHeaderImageUrl"
              class="form-control"
              placeholder="e.g. https://example.com/banner.png" />
            <small style="color: #666; font-size: 0.8rem; display: block; margin-top: 4px;">
              Provide a valid link to a hosted image (.jpg/.png) to send a visual banner at the top of the message.
            </small>
          </div>

          <!-- Queue preview if accepted -->
          <div class="form-group" *ngIf="geoZoneLaunchResult" style="margin-top: 15px;">
            <label>Notification Queued</label>
            <div style="padding: 12px; border-radius: 6px; border: 1px solid #b2f2bb; background-color: #ebfbee; font-size: 0.95rem;">
              <p style="margin: 4px 0; color: #2b8a3e;"><strong>Matched Recipients:</strong> {{ geoZoneLaunchResult.matchedRecipientCount }}</p>
              <p style="margin: 4px 0; color: #2b8a3e;"><strong>Queued for Sending:</strong> {{ geoZoneLaunchResult.queuedCount }}</p>
              <p style="margin: 4px 0; color: #666;" *ngIf="geoZoneLaunchResult.alreadyNotifiedCount > 0"><strong>Already Notified:</strong> {{ geoZoneLaunchResult.alreadyNotifiedCount }}</p>
              <p style="margin: 4px 0; color: #666;" *ngIf="geoZoneLaunchResult.optedOutCount > 0"><strong>Opted Out:</strong> {{ geoZoneLaunchResult.optedOutCount }}</p>
            </div>
            <small style="color: #666; font-size: 0.8rem; display: block; margin-top: 4px;">
              Messages are sent asynchronously — this panel shows scope at submission time, not delivery confirmation.
            </small>
          </div>

          <div class="error-message" *ngIf="errorMessage" style="margin-top: 15px;">
            <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
          </div>

          <div class="success-message" *ngIf="successMessage && !geoZoneLaunchResult" style="margin-top: 15px;">
            <i class="fas fa-check-circle"></i> {{ successMessage }}
          </div>

          <div class="modal-actions">
            <button type="button" class="cancel-btn" (click)="closeGeoZoneLaunchModal()" [disabled]="launchingGeoZoneNotification">
              {{ geoZoneLaunchResult ? 'Close' : 'Cancel' }}
            </button>
            <button type="submit" class="save-btn" style="background-color: #25d366; color: white;" *ngIf="!geoZoneLaunchResult" [disabled]="launchingGeoZoneNotification || !whatsAppLocationParam.trim()">
              <i class="fas fa-spinner fa-spin" *ngIf="launchingGeoZoneNotification"></i>
              <span *ngIf="!launchingGeoZoneNotification"><i class="fab fa-whatsapp"></i> Send WhatsApp</span>
              <span *ngIf="launchingGeoZoneNotification">Queuing...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Geo-Zone Launch Send Log Panel -->
  <div class="details-panel-overlay" *ngIf="showSendLogPanel" (click)="closeSendLogPanel()">
    <div class="details-panel" (click)="$event.stopPropagation()">
      <div class="details-header" style="background: linear-gradient(135deg, #343a40 0%, #495057 100%);">
        <h2>Geo-Zone Launch Send Log</h2>
        <button class="close-btn" (click)="closeSendLogPanel()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="details-body">
        <div class="filter-row" style="margin-bottom: 15px;">
          <div class="filter-group">
            <label for="sendLogStatusFilter">Status</label>
            <select
              id="sendLogStatusFilter"
              [(ngModel)]="sendLogStatusFilter"
              name="sendLogStatusFilter"
              class="filter-select"
              (ngModelChange)="onSendLogStatusFilterChange()">
              <option value="">All</option>
              <option value="Sent">Sent</option>
              <option value="Failed">Failed</option>
            </select>
          </div>
        </div>

        <div class="error-message" *ngIf="sendLogError">
          <i class="fas fa-exclamation-circle"></i> {{ sendLogError }}
        </div>

        <div class="loading" *ngIf="sendLogLoading">
          <p><i class="fas fa-spinner fa-spin"></i> Loading send log...</p>
        </div>

        <div *ngIf="!sendLogLoading && sendLogResponse">
          <div class="pagination-summary">
            <p>{{ sendLogResponse.totalCount || 0 }} log entr{{ (sendLogResponse.totalCount || 0) === 1 ? 'y' : 'ies' }}</p>
          </div>

          <table class="leads-table">
            <thead>
              <tr>
                <th class="col-phone">Phone Number</th>
                <th class="col-status">Status</th>
                <th class="col-updated">Sent At</th>
                <th class="col-template">Template</th>
                <th class="col-error">Error</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of sendLogResponse.items || []" class="lead-row">
                <td class="col-phone">{{ entry.phoneNumber }}</td>
                <td class="col-status">
                  <span [class]="entry.status === 'Sent' ? 'status-badge status-active' : 'status-badge status-rejected'">
                    {{ entry.status }}
                  </span>
                </td>
                <td class="col-updated">{{ entry.sentAt | date:'short' }}</td>
                <td class="col-template">{{ entry.templateName }}</td>
                <td class="col-error">
                  <span *ngIf="entry.errorMessage" style="color: #c92a2a;">{{ entry.errorMessage }}</span>
                  <span *ngIf="!entry.errorMessage" class="no-data">&mdash;</span>
                </td>
              </tr>
              <tr *ngIf="!sendLogResponse.items || sendLogResponse.items.length === 0">
                <td colspan="5" class="no-leads">
                  <p>No send log entries found{{ sendLogStatusFilter ? ' for status ' + sendLogStatusFilter : '' }}.</p>
                </td>
              </tr>
            </tbody>
          </table>

          <app-pagination
            *ngIf="sendLogResponse.items && sendLogResponse.items.length > 0"
            [page]="sendLogCurrentPage"
            [totalPages]="sendLogTotalPages"
            [pageSize]="sendLogPageSize"
            (pageChange)="onSendLogPageChange($event)"
            (pageSizeChange)="onSendLogPageSizeChange($event)">
          </app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>


